import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';

const salonImages = [
  { src: '/images/salon1.jpg', alt: 'The Loft Salon styling floor, bathed in afternoon light' },
  { src: '/images/salon2.jpeg', alt: 'Styling stations and mirrors at The Loft' },
  { src: '/images/salon5.jpeg', alt: 'A stylist’s chair and workspace' },
  { src: '/images/salon3.jpeg', alt: 'The salon’s warm, open layout' },
  { src: '/images/salon4.jpeg', alt: 'Product shelves and styling tools' },
  { src: '/images/salon6.jpeg', alt: 'A quiet corner of the salon' },
  { src: '/images/salon7.jpeg', alt: 'Natural light through the salon windows' },
  { src: '/images/salon8.jpeg', alt: 'Details around the styling stations' },
];

const Salon = () => (
  <div className="page">
    <PageHero kicker="The salon" title="A warm room on the second floor.">
      The Loft sits streetside at Vineyard Commons, full of natural light and the
      easy hum of a busy salon. Here is a look around before you stop in.
    </PageHero>

    <section className="section">
      <div className="container">
        <div className="gallery reveal">
          {salonImages.map((img) => (
            <figure className="gallery__item frame" key={img.src}>
              <img src={img.src} alt={img.alt} loading="lazy" />
            </figure>
          ))}
        </div>
      </div>
    </section>

    <section className="section--tight section--warm">
      <div className="container visit__inner">
        <div className="visit__copy reveal">
          <span className="kicker">Find us</span>
          <h2>Stop by Vineyard Commons.</h2>
          <p className="lede">
            31217 Pauba Rd, Suite 202, Temecula, CA 92592. Second floor,
            streetside. Appointments are encouraged; walk-ins are
            welcome.
          </p>
          <div className="btn-row">
            <a
              className="btn btn--primary"
              href="https://maps.google.com/?q=31217+Pauba+Rd+Suite+202+Temecula+CA+92592"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get directions
            </a>
            <Link to="/team" className="btn btn--outline">Find your stylist</Link>
          </div>
        </div>
        <div className="visit__hours reveal" data-reveal="120">
          <div className="visit__row"><span>Mon – Sat</span><span>10:00am – 5:00pm</span></div>
          <div className="visit__row"><span>Sunday</span><span>Closed</span></div>
          <div className="visit__row"><span>Phone</span><span><a className="link" href="tel:9516946016">(951) 694-6016</a></span></div>
        </div>
      </div>
    </section>
  </div>
);

export default Salon;
